import axios from "axios";
import { getJwtToken } from "./token";

export const get = async ({ url }) => {
    const jwtToken = await getJwtToken();

    return await axios({
        ...axiosConfig(url),
        url: url,
        method: "GET",
        headers: {
            "mt-apigw-authorization": `Bearer ${jwtToken}`,
        },
    })
        .then(response => mapResponse(response))
        .catch(({ response }) => mapResponse(response));
};

export const post = async ({ url, body = {}, headers = {} }) => {
    const jwtToken = await getJwtToken();

    return await axios({
        withCredentials: true,
        url: url,
        method: "POST",
        data: body,
        headers: {
            "mt-apigw-authorization": `Bearer ${jwtToken}`,
            ...headers,
        },
    })
        .then(response => mapResponse(response))
        .catch(({ response }) => mapResponse(response));
};

const mapResponse = response => {
    const { data, status } = response;
    return status >= 200 && status < 400
        ? {
              success: {
                  data: data,
              },
          }
        : {
              error: {
                  data: data,
                  status: status,
              },
          };
};

const axiosConfig = url =>
    url.startsWith("https") ? { withCredentials: true } : {};

export default post;
